export default "__VITE_ASSET__4c28524b__"